import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 대처방안 조회
function getResponsePlanFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/response-plan',
        method: 'get',
        params: {pid}
    })
}

export default getResponsePlanFromMomthera;